export default "__VITE_ASSET__TFFASfhn__"